// extracted by mini-css-extract-plugin
module.exports = {"CludoSearchResults":"cludoSearchResults_CludoSearchResults__Hu5O6","CludoSearchResults_heading":"cludoSearchResults_CludoSearchResults_heading__hEN1J"};